/**
 * ログイン有無を問わないルート
 */
export default [
  {
    path: '/error/system',
    name: 'error.system',
    component: () => import(
      /* webpackChunkName: "error_system" */
      '../views/error/System.vue'
    )
  },
  {
    path: '/error/auth',
    name: 'error.auth',
    component: () => import(
      /* webpackChunkName: "error_auth" */
      '../views/error/Auth.vue'
    )
  },
  {
    path: '/error/not-found',
    name: 'error.not-found',
    component: () => import(
      /* webpackChunkName: "error_not-found" */
      '../views/error/NotFound.vue'
    )
  },
  {
    path: '/error/no-business',
    name: 'error.no-business',
    component: () => import(
      /* webpackChunkName: "error_not-found" */
      '../views/error/NoBusiness.vue'
    )
  },
  {
    path: '/error/visit-token-mismatch',
    name: 'error.visit-token-mismatch',
    component: () => import(
      /* webpackChunkName: "error_visit-token-mismatch" */
      '../views/error/VisitTokenMismatch.vue'
    )
  },
  {
    path: '/oauth2/login',
    name: 'oauth2.login',
    component: () => import(
      /* webpackChunkName: "oauth2_login" */
      '../views/oauth2/Login.vue'
    )
  }
]
